import { useTranslation } from 'react-i18next';
import { isRouteErrorResponse, useRouteError } from 'react-router-dom';

import { AuthPageHeader } from '../auth-page-header/auth-page-header';
import { ErrorBlock } from '../error/error';
import { Layout } from '../layout/layout';

const isNotFound = (error: unknown) => isRouteErrorResponse(error) && error.status === 404;

export const ErrorBoundary = () => {
  const error = useRouteError();
  const { t } = useTranslation();

  return (
    <Layout>
      <AuthPageHeader />
      <ErrorBlock
        title={t('error.title')}
        message={isNotFound(error) ? t('error.notFound') : t('error.common')}
        errorMessage={error instanceof Error ? error.message : undefined}
      />
    </Layout>
  );
};
